module.exports = __webpack_public_path__ + "static/media/background-vid.b4b1450d.mp4";